import type {Icon} from '@primer/octicons-react'
import {Label} from '@primer/react'

import {Pill} from './Pill'

type CommandPillProps = React.ComponentProps<'button'> & {
  children: string
  icon: Icon
  isNew?: boolean
}

export const CommandPill = ({children, icon, isNew = false, ...buttonProps}: CommandPillProps) => (
  <Pill
    leadingVisual={icon}
    trailingVisual={
      isNew ? (
        <Label size="small" variant="accent">
          New
        </Label>
      ) : undefined
    }
    {...buttonProps}
  >
    {children}
  </Pill>
)
